import { Injectable } from '@angular/core';

import {PROVERB_BOOKMARK_API_URL} from '../../defines/protocol';
import {ApiService} from '../api/api.service';
import {ProverbService} from './proverb.service';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {TotalService} from '../total/total.service';

@Injectable({
  providedIn: 'root'
})
export class ProverbBookmarkService extends ProverbService {

  constructor(
    protected override api: ApiService,
    private totalSvc: TotalService,
  ) {
    super(api);
    this.urlApi = PROVERB_BOOKMARK_API_URL;
  }

  /**
   * 속담을 책갈피에 추가/삭제하도록 서버에 요청
   * 화면(listProverb)와는 관계 없다.
   * @param id: 추가할 속담 번호
   * @param add: 추가/삭제 여부
   */
  public sendBookmark(id: string, add: boolean = true): Observable<boolean> {
    const url = this.urlApi + id + '/';
    const obs = add ?
      this.api.Post(url, null) :
      this.api.Delete(url);

    return obs.pipe(
      map(data => {
        console.log('sendBookmark', id, add, data);
        this.totalSvc.updateProverbBookmarkCount(add);
        return data;
      }),
      // catchError((err, caught) => {
      //   console.error('sendBookmark', id, add, err);
      //   throwError(err);
      //   return caught;
      // })
    );
  }

  /**
   * 지정한 속담을 표시 목록에서 제거한다.
   * this.listProverb 에서 제거하면 화면에서 지워진다.
   * @param id: 제거할 속담 번호
   */
  public hideBookmark(id: string): void {
    if (this.totalCount === null || this.listProverb === null || this.mapProverb === null) {
      console.warn('ProverbBookmarkService::hideBookmark() list not loaded yet, id=', id);
      return;
    }

    const idx = this.listProverb.findIndex(proverb => proverb.id === id);
    if (idx !== -1) {
      this.listProverb.splice(idx, 1);
      this.mapProverb.delete(id);
      --this.totalCount;
    }
    else {
      console.warn(`ProverbBookmarkService::hideBookmark(${id}) proverb does not exist`);
    }
  }
}
